
import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const ContactSection: React.FC = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    tipoEmpresa: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    // Validate form
    if (!formData.nome || !formData.email || !formData.telefone || !formData.tipoEmpresa) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    // Validate textarea length
    if (formData.mensagem.length > 500) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4dg3b2els5gugpjmnlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          tipoEmpresa: '',
          mensagem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contato" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-[#1A3A52] mb-6 font-['Playfair_Display']">
            Fale Conosco
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Entre em contato e descubra como podemos ajudar sua empresa a crescer
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Contact Information */}
          <div>
            <div className="mb-12">
              <h4 className="text-2xl font-bold text-[#1A3A52] mb-8">
                Informações de Contato
              </h4>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#00A896] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-[#1A3A52] mb-1">Endereço</h5>
                    <p className="text-gray-600">
                      Rua Marechal Deodoro, 630 - Sala 1204<br />
                      Centro, Curitiba - PR, 80010-912
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#00A896] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-[#1A3A52] mb-1">Telefone</h5>
                    <a 
                      href="tel:+554132257788" 
                      className="text-gray-600 hover:text-[#00A896] transition-colors cursor-pointer"
                    >
                      (41) 3225-7788
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-[#1A3A52] mb-1">WhatsApp</h5>
                    <a 
                      href="https://wa.me/5541996543210" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-gray-600 hover:text-[#25D366] transition-colors cursor-pointer"
                    >
                      (41) 99654-3210
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#00A896] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-[#1A3A52] mb-1">E-mail</h5>
                    <a 
                      href="mailto:contato@contecontabil.com.br"
                      className="text-gray-600 hover:text-[#00A896] transition-colors cursor-pointer"
                    >
                      contato@contecontabil.com.br
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#00A896] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-[#1A3A52] mb-1">Horário de Atendimento</h5>
                    <p className="text-gray-600">
                      Segunda a Sexta: 8h30 às 18h
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Maps */}
            <div className="rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.0234567890123!2d-49.2733!3d-25.4284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDI1JzQyLjIiUyA0OcKwMTYnMjMuOSJX!5e0!3m2!1spt-BR!2sbr!4v1234567890123"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização da Conte Assessoria Contábil"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <div className="bg-[#F8F9FA] rounded-xl p-8">
              <h4 className="text-2xl font-bold text-[#1A3A52] mb-6">
                Solicitar Contato
              </h4>
              
              <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="nome" className="block text-sm font-medium text-[#1A3A52] mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00A896] focus:border-transparent text-sm"
                      placeholder="Seu nome completo"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-[#1A3A52] mb-2">
                      E-mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00A896] focus:border-transparent text-sm"
                      placeholder="seu@email.com"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="telefone" className="block text-sm font-medium text-[#1A3A52] mb-2">
                      Telefone *
                    </label>
                    <input
                      type="tel"
                      id="telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00A896] focus:border-transparent text-sm"
                      placeholder="(41) 99999-9999"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="tipoEmpresa" className="block text-sm font-medium text-[#1A3A52] mb-2">
                      Tipo de Empresa *
                    </label>
                    <div className="relative">
                      <select
                        id="tipoEmpresa"
                        name="tipoEmpresa"
                        value={formData.tipoEmpresa}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00A896] focus:border-transparent text-sm pr-8 appearance-none"
                      >
                        <option value="">Selecione</option>
                        <option value="MEI">MEI</option>
                        <option value="Microempresa">Microempresa</option>
                        <option value="Pequena Empresa">Pequena Empresa</option>
                        <option value="Média Empresa">Média Empresa</option>
                        <option value="Startup">Startup</option>
                        <option value="E-commerce">E-commerce</option>
                        <option value="Profissional Liberal">Profissional Liberal</option>
                        <option value="ONG/Associação">ONG/Associação</option>
                        <option value="Outro">Outro</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                    </div>
                  </div>
                </div>

                <div className="mb-6">
                  <label htmlFor="mensagem" className="block text-sm font-medium text-[#1A3A52] mb-2">
                    Mensagem
                  </label>
                  <textarea
                    id="mensagem"
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleInputChange}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00A896] focus:border-transparent text-sm resize-none"
                    placeholder="Conte-nos sobre suas necessidades contábeis..."
                  ></textarea>
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.mensagem.length}/500 caracteres
                  </div>
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  className="w-full"
                  onClick={undefined}
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line mr-2 animate-spin"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line mr-2"></i>
                      Solicitar Contato
                    </>
                  )}
                </Button>

                {submitStatus === 'success' && (
                  <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    <i className="ri-check-circle-line mr-2"></i>
                    Mensagem enviada com sucesso! Entraremos em contato em breve.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    <i className="ri-error-warning-line mr-2"></i>
                    Erro ao enviar mensagem. Verifique os dados e tente novamente.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
